import axios from "axios";
import _ from 'lodash';
import React, { Component } from "react";
import reactDom from "react-dom";
import { Link } from "react-router-dom";
import AsyncSelect from 'react-select/async';
import AfterLoginMenu from "../../routes/AfterLoginMenu";
import BeforeLoginMenu from "../../routes/BeforeLoginMenu";
import lowCostPopupContext from '../data/popup-text.json';



class Home extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.selectRef = React.createRef();
        this.ocrProcessRef = React.createRef();
        this.externalLinks = React.createRef();
        this.OcrlastStep = React.createRef();
        this.unclickableArea = React.createRef()
        this.codeDescriptionRef = React.createRef()
        this.state = {
            token: localStorage.getItem("token"),
            medicalCode: '',
            stateName: '',
            stateCode: '',
            msaName: '',
            msaID: '',
            errorMessage: "",
            Setting: [],
            FilterSetting: [],
            states: [],
            msa: [],
            lives: '',
            accumulator: '',
            hasApi: '',
            lowCostPopupContext: lowCostPopupContext,
            hasSentMessage: false,
            mobileNumber: '',
            countryNumber: '+1',
            hasOpenPhone: false,
            isOOPSearchable: false,
            nextSearchDate: '',
            unclickableAreaheight: '',
            captchaResponse: null,
            codeDiscription: [],
            codeDiscriptionFilterd: [],
            codeDiscriptionPopup: false,
            searchText: '',
            isCodeDescriptionLoade: false,
            msaTableName: '',
            paymentMethod: '',
            individualSubscription: false,
            individualSubscriptionCount: 0,
            reportType: null,
            downloadInProcess: false,
            hospitalList: [],
            selectedHospitalId: '',
            selectedHospitalname: '',
            phoneNumber: '',
            files: [],
            uploading: false,
            response: null,
            paymentSusscess: false,
            ocrInProcess: false,
            isPhoneChecked: false,
            employer_OCR: false,
            oCR_Access: false,
            uploadError: false,
            uploadErrorMessage: '',
            specialtyList: [],
            Specialty: '',
        };
        this.oopSubmit = this.oopSubmit.bind(this);
        this.oopCustomSubmit = this.oopCustomSubmit.bind(this);
        this.alertChange = this.alertChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.numberValid = this.numberValid.bind(this);
        this.getReportType = this.getReportType.bind(this);
        this.handleMsaChange = this.handleMsaChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.loadOptions = _.debounce(this.loadOptions.bind(this), 100);
        this.handelCodeSelect = this.handelCodeSelect.bind(this);
        this.getAllSetting = this.getAllSetting.bind(this);
        this.handleSettingChange = this.handleSettingChange.bind(this);
        this.handleSpecialtyChange = this.handleSpecialtyChange.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }

    handleClickOutside = event => {
        const domNode = reactDom.findDOMNode(this.codeDescriptionRef.current);

        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                codeDiscriptionPopup: false
            });
        }
    }

    handleFileChange = (event) => {
        this.setState({ files: Array.from(event.target.files) });

    };

    refreshToken() {
        const token = localStorage.getItem("token");
        const refreshToken = localStorage.getItem("refreshToken");
        const expired = localStorage.getItem("expired");

        if (token !== null && refreshToken !== null && expired !== null) {
            axios
                .post(
                    `${process.env.REACT_APP_API_URL}api/auth/refreshToken`,
                    {
                        token: token,
                        refreshToken: refreshToken,
                        expiration: expired,
                    }
                )
                .then((response) => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem(
                        "refreshToken",
                        response.data.refreshToken
                    );
                    localStorage.setItem("expired", response.data.expiration);
                })
                .catch((error) => {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 401 ||
                        error.response.status === 403
                    ) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("email");
                        localStorage.removeItem("secret_key");
                        localStorage.removeItem("refreshToken");
                        localStorage.removeItem("expired");
                        this.props.history.push("/login");
                    }
                });
        }
    }

    getaccessAllState() {
        const reportStatus = JSON.parse(localStorage.getItem("reportType"));
        const umail = reportStatus.replace_Email !== null ?
            reportStatus.replace_Email : reportStatus.actual_Email;

        axios
            .get(
                `${process.env.REACT_APP_API_URL
                }api/OobRates/getoobratesStatewiseUserAccess?email=${umail}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                this.setState({
                    states: Object.values(response.data),
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.clear()
                    this.props.history.push("/logout");
                }
            });
    }

    getAllSetting() {
        axios
            .get(
                `${process.env.REACT_APP_API_URL
                }api/OobRates/getoobratesSetting`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                // console.log(response.data)
                this.setState({
                    Setting: response.data,
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.clear()
                    this.props.history.push("/logout");
                }
            });
    }

    getAllHospital(statename, msaID) {
        const filter = {
            statename: statename,
            msaId: msaID,
        };
        const filterJson = encodeURIComponent(JSON.stringify(filter));
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/Inventory/getHospitalbyFilter?FilterJson=${filterJson}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                // console.log(response.data)
                this.setState({
                    hospitalList: response.data,
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.clear()
                    this.props.history.push("/logout");
                }
            });
    }

    getSpecialty() {
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/Subscription/getSpecialty`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                console.log(response.data)
                this.setState({
                    specialtyList: response.data,
                });

            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.clear()
                    this.props.history.push("/logout");
                }
            });
    }

    handleStateChange(event) {
        this.setState({
            stateName: event.target.value,
            msaName: '',
            codeDiscription: [],
            codeDiscriptionFilterd: [],
            searchText: '',
            medicalCode: ''
        });
        this.selectRef.current.setValue('')
        const stateFilter = this.state.states.filter(i => i.stateName === event.target.value);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/Subscription/getmsafilter?stateCode=${stateFilter[0].stateCode}&specialty=${this.state.Specialty}`,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                this.setState({
                    msa: Object.values(response.data),
                    stateCode: stateFilter[0].stateCode
                });
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("email");
                    localStorage.removeItem("userID");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("secret_key");
                    localStorage.removeItem("refreshToken");
                    localStorage.removeItem("expired");
                    this.props.history.push("/login");
                }
            });
    }

    handleSettingChange(event) {
        this.setState({
            paymentMethod: event.target.value
        });
    }

    handleSpecialtyChange(event) {
        this.setState({
            Specialty: event.target.value,
            paymentMethod: ''
        });
    }
    getBillingClasses() {
        const setting = this.state.Setting || [];

        const uniqueSettings = [
            ...new Map(
                setting.map(item => [
                    item.trim().toLowerCase(),
                    item.trim()
                ])
            ).values()
        ];
        if (
            (this.state.Specialty.trim().toLowerCase() ===
                'Hospital Cash Rates'.trim().toLowerCase()) || (this.state.Specialty.trim().toLowerCase() === 'Hospital Cash Prices'.trim().toLowerCase())
        ) {
            return uniqueSettings.filter(
                item =>
                    item.toLowerCase() === 'professional' ||
                    item.toLowerCase() === 'facility only'
            );
        }

        return [
            ...new Map(
                ['Professional',
                    'Institutional',
                    // ...uniqueSettings
                ].map(item => [
                    item.trim().toLowerCase(),
                    item
                ])
            ).values()
        ];
    }

    checkEmployersAccess() {
        const reportStatus = JSON.parse(localStorage.getItem("reportType"));
        const umail = reportStatus.replace_Email !== null ?
            reportStatus.replace_Email : reportStatus.actual_Email;
        const filter = {
            'accout': umail,
        }
        axios
            .post(
                `${process.env.REACT_APP_API_URL
                }api/OobRates/getoobratesEmployersAccess`, filter,
                {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`,
                        secret_key: localStorage.getItem("secret_key"),
                    },
                }
            )
            .then((response) => {
                this.setState({
                    hasApi: response.data[0].API
                })
            })
            .catch((error) => {
                if (
                    error.response.status === 400 ||
                    error.response.status === 401 ||
                    error.response.status === 403
                ) {
                    localStorage.clear()
                    this.props.history.push("/logout");
                }
            });
    }

    // oop filter 
    oopSubmit() {
        if (this.state.token !== null) {
            const stateFilter = this.state.states.filter(i => i.stateName === this.state.stateName);
            const filter = {
                'stateName': this.state.stateName,
                'msaID': this.state.msaID,
                'msaName': this.state.msaName,
                'code': this.state.medicalCode,
                'accout': localStorage.getItem('userName'),
                'stateCode': stateFilter[0].stateCode,
                'Specialty': this.state.Specialty,
                'paymentMethod': this.state.paymentMethod,
                'tableName': this.state.msaTableName,
                'needIndvLog': true,
            }
            sessionStorage.removeItem("oopflcus")
            sessionStorage.setItem("oopfl", JSON.stringify(filter));
            this.props.history.push("/ooprates");

        } else {
            this.setState({
                errorMessage: "You need to login first"
            });
        }
    }

    async handleExportClick() {
        const reportStatus = JSON.parse(localStorage.getItem("reportType"));
        const umail = reportStatus.replace_Email !== null ?
            reportStatus.replace_Email : reportStatus.actual_Email;

        const filter = {
            'code': this.state.medicalCode.procedureCode,
            'accout': umail,
            'stateName': this.state.stateName,
            'msaID': this.state.msaID,
            'msaName': this.state.msaName,
            'paymentMethod': this.state.paymentMethod.toUpperCase(),
            'userId': localStorage.getItem("userID")
        };

        try {
            this.setState({ downloadInProcess: true })
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}api/OobRates/exportOobData?oobinput=${JSON.stringify(filter)}`,
                {
                    responseType: 'blob', // Blob response for file download
                    // onDownloadProgress: (progressEvent) => {
                    //     if (progressEvent.total) {
                    //       const percentCompleted = Math.round(
                    //         (progressEvent.loaded * 100) / progressEvent.total
                    //       );
                    //       this.setState({ progress: percentCompleted }); // Update progress in state
                    //       console.log(percentCompleted); // Log progress for debugging
                    //     }
                    //   },
                }
            );

            // Extract filename from Content-Disposition header
            const contentDisposition = response.headers['content-disposition'];
            let filename = `${this.state.stateName}.xlsx`; // Default filename
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1]);
                }
            }

            // Create a URL for the file and initiate download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Use the extracted filename
            document.body.appendChild(link);
            link.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            link.remove();

            // Call the second API after the file download is initiated successfully
            const followUpResponse = await axios.get(`${process.env.REACT_APP_API_URL}api/OobRates/logIndvsubscount`, {
                headers: {
                    "userId": localStorage.getItem("userID")
                }
            });
            this.setState({ downloadInProcess: false })
            this.getReportType()
        } catch (error) {
            this.setState({ downloadInProcess: false })
            console.error('An error occurred:', error);
        }

    }


    // oop filter 
    oopCustomSubmit() {
        if (this.state.token !== null) {
            const stateFilter = this.state.states.filter(i => i.stateName === this.state.stateName);
            const filter = {
                'stateName': this.state.stateName,
                'msaID': this.state.msaID,
                'msaName': this.state.msaName,
                'code': this.state.medicalCode,
                'lives': this.state.lives,
                'accumulator': this.state.accumulator,
                'accout': localStorage.getItem('userName'),
                'stateCode': stateFilter[0].stateCode,
                'Specialty': this.state.Specialty,
                'paymentMethod': this.state.paymentMethod,
                'tableName': this.state.msaTableName,
                'needIndvLog': true,
            }
            // console.log(this.state.stateName, this.state.msaName, this.state.medicalCode, this.state.lives, this.state.accumulator)
            sessionStorage.removeItem("oopfl")
            sessionStorage.setItem("oopflcus", JSON.stringify(filter));
            this.props.history.push("/ooprates");

        } else {
            this.setState({
                errorMessage: "You need to login first"
            });
        }
    }

    alertChange() {
        this.setState({
            errorMessage: ""
        });
    }

    numberValid(num) {
        const re = /^[0-9\b]+$/;
        return re.test(num)
    }

    getReportType() {
        const accout = localStorage.getItem('userName');
        const userId = localStorage.getItem('userID');

        if (this.state.token !== null && accout !== null) {

            axios
                .get(
                    `${process.env.REACT_APP_API_URL
                    }api/OobRates/getReportType?email=${accout}&userId=${userId}`
                )
                .then((response) => {
                    localStorage.setItem("reportType", JSON.stringify(response.data[0]));
                    console.log(response.data[0].searching_Status)
                    if (response.data[0].searching_Status === 1) {
                        this.getaccessAllState();
                        this.checkEmployersAccess();
                        this.setState({
                            isOOPSearchable: true
                        });
                        console.warn(response.data[0].searching_Status)
                    } else {
                        this.setState({
                            isOOPSearchable: false,
                            nextSearchDate: new Date(response.data[0]?.next_Search_Date)
                        });
                    }
                    this.setState({
                        individualSubscription: response.data[0].individualSubscription,
                        individualSubscriptionCount: response.data[0].individualSubscriptionCount,
                        reportType: response.data[0].reportType,
                        employer_OCR: response.data[0].employer_OCR,
                        oCR_Access: response.data[0].oCR_Access,
                        nextSearchDate: new Date(response.data[0]?.next_Search_Date)
                    });
                })
                .catch((error) => {
                    if (
                        error.response.status === 400 ||
                        error.response.status === 401 ||
                        error.response.status === 403
                    ) {
                        localStorage.clear()
                        this.props.history.push("/logout");
                    }
                });

        } else {
            this.setState({
                errorMessage: "You need to login first"
            });
        }
    }

    withoutLoginClick() {
    }

    handleMsaChange(event) {
        const TableNameFilter = this.state.msa.filter(i => i.msaID === +event.target.value);
        this.setState({
            msaID: event.target.value,
            msaName: event.target.selectedOptions[0].getAttribute('msaname'),
            codeDiscription: [],
            codeDiscriptionFilterd: [],
            searchText: '',
            isCodeDescriptionLoade: true,
            msaTableName: TableNameFilter[0]?.TableName,
            medicalCode: ''
        })
        this.selectRef.current.setValue('');
        this.getAllHospital(this.state.stateName, event.target.value)
    }

    handleSearchChange(value) {
        this.setState({
            searchText: value,
        });
        return value;
    }

    getOptionValue = (option) => option.procedureCode;

    getOptionLabel = (option) => `(${option.procedureCode}) ${option.codeDescription}`;

    // load options using API call
    loadOptions(value, callback) {
        const fdata = {
            stateCode: this.state.stateCode,
            msaName: this.state.msaName,
            specialty: this.state.Specialty.trim(),
            queryText: this.state.searchText,
        }
        if (!value) {
            return callback([]);
        }
        axios
            .get(
                `${process.env.REACT_APP_API_URL}api/OobRates/GetCodeDescriptionbyMSA?FilterJson=${JSON.stringify(fdata)}`
            )
            .then((response) => {

                if (response.data.length) {
                    let dataModified;
                    dataModified = response?.data?.map(
                        obj => {
                            return {
                                "procedureCode": obj?.procedureCode.trim(),
                                "codeDescription": obj?.codeDescription.trim()
                            }
                        }
                    );
                    this.setState({
                        codeDiscription: dataModified
                    });
                    callback(this.mapOptionsToValues(dataModified))

                    sessionStorage.setItem("codeDiscription", JSON.stringify(dataModified));
                } else {
                    this.setState({
                        codeDiscription: []
                    });
                    callback(this.mapOptionsToValues([]))
                    sessionStorage.setItem("codeDiscription", JSON.stringify([]));
                }

            })
            .catch((error) => {
                console.log(error)
            });


    };

    handelCodeSelect(event) {
        console.log(event)
        this.setState({
            medicalCode: event
        })
    }

    mapOptionsToValues = options => {
        return options.map(option => ({
            procedureCode: option.procedureCode,
            codeDescription: option.codeDescription
        }));
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
        this.refreshToken();
        if (this.state.token !== null) {
            this.unclickableArea.current.style.display = "none";
            this.getReportType();
            this.getAllSetting();
            this.getSpecialty();
        } else {
            this.unclickableArea.current.style.display = "block";
            //console.log(this.externalLinks.current.clientHeight)
            this.setState({
                unclickableAreaheight: this.externalLinks.current.clientHeight
            })
        }

        const queryParams = new URLSearchParams(this.props.location.search);
        const unique_ID = queryParams.get('unique_ID');
        const ocrData = JSON.parse(sessionStorage.getItem("ocrData"));
        if (unique_ID === ocrData?.unique_ID) {
            this.setState({
                paymentSusscess: true,
                ocrInProcess: true
            })
            this.OcrlastStep.current.click();
        }

    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    handleUpload = async () => {
        const { files } = this.state;
        if (files.length === 0) {
            alert("Please select files first!");
            return;
        }


        const reqjson = {
            userID: localStorage.getItem("userID"),
            email: localStorage.getItem("email"),
            stateName: this.state.stateName,
            msaName: this.state.msaName,
            HospitalID: this.state.selectedHospitalId,
            billingClass: this.state.paymentMethod,
            phoneNumber: this.state.phoneNumber ? this.state.countryNumber + this.state.phoneNumber : null,
            employeedc: this.state.individualSubscription ? true : this.state.employer_OCR,
        }

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append("files", file); // The key should match your API's expected key
        });

        formData.append("directory", localStorage.getItem("userID"));
        formData.append("ocrFileDetails", JSON.stringify(reqjson));

        this.setState({ uploading: true });

        try {
            const result = await axios.post(`${process.env.REACT_APP_API_URL
                }api/MobileApplication/uploadOcrFileToBlob`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (result.data.isSuccess) {
                const StoreData = {
                    "state": this.state.stateName,
                    "msa": this.state.msaID,
                    "msaname": this.state.msaName,
                    "hospital": this.state.selectedHospitalId,
                    "hospitalname": this.state.hospitalList.filter(i => i.hospitalID === +this.state.selectedHospitalId)[0]?.facilityName,
                    "billClass": this.state.paymentMethod,
                    "responseData": result.data.data,
                    "unique_ID": result.data.unique_ID,
                    "employers_dc": result.data?.employers_dc,
                }
                sessionStorage.setItem("ocrData", JSON.stringify(StoreData));
                this.setState({ response: result.data }); // Store the API response
                console.log(result.data);
            } else {
                this.setState({ uploadError: true, uploadErrorMessage: result.data[0].msg });
            }

            // if(!result.data.isSuccess) alert("Files uploaded successfully!");

        } catch (error) {
            console.error("Error uploading files", error);
            alert("Error uploading files");
        } finally {
            this.setState({ uploading: false });
        }
    };






    render() {
        return (
            <>
                {this.state.token !== null ? (
                    <AfterLoginMenu />
                ) : (
                    <BeforeLoginMenu />
                )}
                <main role="main">
                    <div className="home-banner-image py-3">
                        <div className="container py-4">
                            <div className="row">
                                <div className="col-md-7 pt-3">
                                    <h4 className="text-white bannerFontsize">
                                        <em>
                                            Out of pocket cost is derived from the negotiated rate.  A lower negotiated rate yields a lower out of pocket cost.  Choose plans with a lower negotiated rate and you save money.
                                        </em>
                                    </h4>
                                    {/* <p className="text-white">
                                        <em>--- Thomas Sowell</em>
                                    </p> */}

                                    <div className="row mt-1  ml-0 mr-0 oop-m position-relative" >

                                        {
                                            this.state.errorMessage ? <><div className="col-md-12"><div className="alert alert-danger alert-dismissible fade show py-2" role="alert">
                                                {this.state.errorMessage}
                                                <button type="button" className="close py-2" data-dismiss="alert" aria-label="Close" onClick={this.alertChange}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div></div> </> :
                                                ''
                                        }

                                        {/* if all are unclickable  */}
                                        <div className="area_unclickable" ref={this.unclickableArea} style={{ height: `calc(100% - ${this.state.unclickableAreaheight}px)` }} data-toggle="modal" data-target="#unclickable_Modal"></div>

                                        {/* payment Under process modal  */}
                                        <div className="modal fade" id="unclickable_Modal" data-backdrop="static">
                                            <div className="modal-dialog modal-dialog-scrollable payment_process_modal modal-dialog-centered">
                                                <div className="modal-content ">

                                                    <div className="modal-body unclickable_Modal_body">
                                                        <button type="button" className="close" data-dismiss="modal">
                                                            &times;
                                                        </button>
                                                        <p>Please create an account or login first</p>
                                                        <Link
                                                            to="/registration"
                                                            data-dismiss="modal"
                                                            onClick={() => this.props.history.push("/registration")}
                                                        >Create New Account
                                                        </Link>|
                                                        <Link
                                                            to="/login"
                                                            data-dismiss="modal"
                                                            onClick={() => this.props.history.push("/login")}
                                                        >Already have a account
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12  my-2 pl-2 pr-2">
                                            <select
                                                className="md-form mdb-select white-bg form-control w-100"
                                                name="selectSpecialty"
                                                onChange={(e) => this.handleSpecialtyChange(e)}
                                                required
                                                value={this.state.Specialty}
                                                disabled={this.state.token === null || this.state.specialtyList[0]?.specialty === undefined}

                                            >
                                                <option value="">Select Specialty</option>
                                                {
                                                    this.state.specialtyList[0]?.specialty !== undefined ?
                                                        this.state.specialtyList
                                                            .sort((a, b) => a.specialty.localeCompare(b.specialty))
                                                            .map((stateArr, index) => (
                                                                <option
                                                                    value={
                                                                        stateArr.specialty
                                                                    }
                                                                    key={index}
                                                                >
                                                                    {`${stateArr.specialty}`}
                                                                </option>
                                                            ))
                                                        : ''
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12  my-2 pl-2 pr-2">
                                            <select
                                                className="md-form mdb-select white-bg form-control w-100"
                                                name="selectState"
                                                onChange={(e) => this.handleStateChange(e)}
                                                required
                                                value={this.state.stateName}
                                                disabled={this.state.token === null || this.state.states[0]?.stateName === undefined}

                                            >
                                                <option value="">Select State</option>
                                                {
                                                    this.state.states[0]?.stateName !== undefined ?
                                                        this.state.states
                                                            .sort((a, b) => a.stateName.localeCompare(b.stateName))
                                                            .map((stateArr, index) => (
                                                                <option
                                                                    value={
                                                                        stateArr.stateName
                                                                    }
                                                                    key={index}
                                                                >
                                                                    {`${stateArr.stateName} (${stateArr.stateCode})`}
                                                                </option>
                                                            ))
                                                        : ''
                                                }
                                            </select>
                                        </div>

                                        <div className="col-md-6 col-sm-6  col-12 my-2  pl-2 pr-2">
                                            <select
                                                className="md-form mdb-select white-bg form-control w-100"
                                                name="selectMsa"
                                                // onChange={(e) => this.setState({ msaID: e.target.value, msaName: e.target.selectedOptions[0].getAttribute('msaname') })}
                                                onChange={(e) => this.handleMsaChange(e)}
                                                required
                                                value={this.state.msaID}
                                                disabled={this.state.token === null || this.state.stateName === ''}
                                            >
                                                <option value="">Select Metro Area</option>
                                                {
                                                    this.state.msa !== undefined ?
                                                        this.state.msa.map((msaArr, index) => (
                                                            <option value={msaArr.msaID} msaname={msaArr.MSA} key={index}>{msaArr.MSA}</option>
                                                        ))
                                                        : ''
                                                }
                                            </select>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-12 my-2 pl-2 pr-2">
                                            <AsyncSelect
                                                ref={this.selectRef}
                                                cacheOptions
                                                placeholder={'Medical Code / Code Description'}
                                                noOptionsMessage={() => this.state.searchText === '' ? 'Please enter some value to search Medical Code / Code Description' : 'Nothing found'}
                                                loadingMessage={() => 'Searching...'}
                                                defaultOptions={this.state.codeDiscription}
                                                defaultValue={this.state.medicalCode}
                                                loadOptions={this.loadOptions}
                                                getOptionValue={this.getOptionValue}
                                                getOptionLabel={this.getOptionLabel}
                                                onInputChange={(e) => this.handleSearchChange(e)}
                                                onChange={this.handelCodeSelect}
                                                isClearable
                                                isDisabled={this.state.stateName == '' || this.state.msaName == '' || this.state.msaID == '' ? true : false}
                                            />

                                        </div>

                                        <div className="col-md-6 col-sm-6 col-12  my-2 pl-2 pr-2">
                                            <select
                                                className="md-form mdb-select white-bg form-control w-100"
                                                name="paymentMethod"
                                                onChange={(e) => this.handleSettingChange(e)}
                                                required
                                                value={this.state.paymentMethod}
                                                disabled={this.state.token === null || !this.state.Setting.length}

                                            >
                                                <option value="">Select Billing Class</option>
                                                {
                                                    this.getBillingClasses().map((billingClass, index) => (
                                                        <option
                                                            value={billingClass}
                                                            key={index}
                                                        >
                                                            {billingClass}
                                                        </option>
                                                    ))
                                                }
                                            </select>
                                        </div>

                                        <div className="col-12 my-2 pl-2 pr-2">
                                            {
                                                this.state.individualSubscription && this.state.isOOPSearchable && this.state.individualSubscriptionCount > 0 ?
                                                    <button className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn" disabled={this.state.stateName == '' || this.state.medicalCode == '' || this.state.msaName === '' || this.state.codeDiscriptionPopup || this.state.paymentMethod == '' || this.state.downloadInProcess} onClick={this.oopSubmit}>
                                                        {
                                                            this.state.downloadInProcess ?
                                                                'Downloading...' : 'Get Rates'
                                                        }
                                                    </button>
                                                    :
                                                    this.state.hasApi?.toLowerCase().trim('') === 'yes' ?
                                                        <button className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn" disabled={this.state.stateName == '' || this.state.medicalCode == '' || this.state.msaName === '' || this.state.codeDiscriptionPopup || this.state.paymentMethod == ''} onClick={this.oopSubmit}>Get Rates</button>
                                                        :
                                                        <>
                                                            {
                                                                this.state.hasApi?.toLowerCase().trim('') === 'no' ?
                                                                    <button className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn" disabled={this.state.stateName == '' || this.state.medicalCode == '' || this.state.msaName === '' || this.state.codeDiscriptionPopup || this.state.paymentMethod == ''} data-toggle="modal" data-target="#OOP_Modal">Get Rates</button>
                                                                    :
                                                                    <button className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn" disabled='true' >Get Rates</button>
                                                            }

                                                        </>

                                            }

                                            {/* <span data-toggle="modal"
                                                data-target="#OOP_Modal" ref={this.ref}></span> */}
                                        </div>
                                        {/* banner link */}
                                        <div className="col-12 pl-2 pr-2" ref={this.externalLinks}>
                                            {
                                                !this.state.isOOPSearchable && this.state.nextSearchDate !== '' ?
                                                    <p className="next_search_text"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {`Your next eligible search begins on ${this.state.nextSearchDate.toLocaleDateString('en-US')}`}</p> : ''
                                            }

                                            {
                                                !this.state.isOOPSearchable && this.state.individualSubscriptionCount > 0 && this.state.reportType != null ?
                                                    <p className="next_search_text"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {`Your subscription has expired. Renew within 24 hours to carry forward ${this.state.individualSubscriptionCount} remaining searches along with new search credits.`}</p> : ''
                                            }

                                            <p style={{ color: "#e8ac4c", marginBottom: '0.6rem' }}>
                                                <i class="fa fa-info-circle" aria-hidden="true"></i> This information is provided free of charge to help you with your medical bills.  If your intent is to use this data commercially please buy a subscription from us.  Thank you.
                                            </p>
                                            {/* <a href="https://ratings.leapfroggroup.org/" target="_blank" title="Search Leapfrog’s Hospital and Surgery Center Ratings | Hospital and Surgery Center Ratings | Leapfrog Group" className="ext_link"><i className="fa fa-external-link" aria-hidden="true"></i>&nbsp;Hospital and Surgery Center Ratings</a>
                                            <a href="https://www.medicare.gov/care-compare/?providerType=Physician&redirect=true#search" target="_blank" title="Find Healthcare Providers: Compare Care Near You | Medicare" className="ext_link"><i className="fa fa-external-link" aria-hidden="true"></i>&nbsp;Find Healthcare Providers: Compare Care Near You | Medicare</a>
                                            <a href="javascript:;" data-toggle="modal" data-target="#Omega_Notes" title="Omega Notes" className="ext_link"><i className="fa fa-window-restore" aria-hidden="true"></i>&nbsp;Omega Notes</a> */}
                                            {/* <a href="https://www.jasonhealth.com/" target="_blank" title="Walk-in Blood Tests in a Lab Near You - Order Online - Jason Health" className="ext_link"><i className="fa fa-external-link" aria-hidden="true"></i>&nbsp;Walk-in Blood Tests in a Lab Near You - Order Online - Jason Health</a> */}
                                            <a href="javascript:;" data-toggle="modal" data-target="#buy_low_cost_Modal" title="How to buy low cost healthcare" className="ext_link"><i className="fa fa-window-restore" aria-hidden="true"></i>&nbsp;How to buy low cost healthcare</a>
                                            {/*<a href="javascript:;" data-toggle="modal" data-target="#Surgical_Imaging" title="Are you a Surgical or Imaging Center" className="ext_link"><i className="fa fa-window-restore" aria-hidden="true"></i>&nbsp;Are you a Surgical or Imaging Center</a>*/}
                                            <a href="javascript:;" data-toggle="modal" data-target="#Surgical_Imaging" title="Upload and reprice your medical bill" className="ext_link"><i className="fa fa-window-restore" aria-hidden="true"></i>&nbsp;Upload and reprice your medical bill</a>
                                            <a href="https://www.gnanow.org/" target="_blank" title=" Independent Patient Advocates | Greater National Advocates (gnanow.org)" className="ext_link"><i className="fa fa-external-link" aria-hidden="true"></i>&nbsp;Overwhelmed with healthcare and need an advocate?</a>
                                            {/* <a href="javascript:;" data-toggle="modal" data-target="#Hospital_Survey" title="Hospital Survey" className="ext_link"><i className="fa fa-window-restore" aria-hidden="true"></i>&nbsp;Hospital Survey</a> */}

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* oop modal  */}
                        <div className="modal fade" id="OOP_Modal" data-backdrop="static">
                            <div className="modal-dialog modal-dialog-scrollable oop_modal">
                                <div className="modal-content ">
                                    <div className="modal-body ">
                                        <button type="button" className="close" data-dismiss="modal">
                                            &times;
                                        </button>
                                        <div className="form-group">
                                            <label className="oopLabel d-block">Select family status: </label>
                                            <div className="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="oopFamilyStatus1" name="oopFamilyStatus" className="custom-control-input"
                                                    onChange={() => this.setState({ lives: '1' })} />
                                                {/* checked={this.state.lives === '1'} */}
                                                <label className="custom-control-label" htmlFor="oopFamilyStatus1">Single</label>
                                            </div>
                                            <div className="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="oopFamilyStatus2" name="oopFamilyStatus" className="custom-control-input"
                                                    onChange={() => this.setState({ lives: '2' })} />
                                                {/* checked={this.state.lives === '2'} */}
                                                <label className="custom-control-label" htmlFor="oopFamilyStatus2">Family</label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="oopLabel">Enter YTD medical spend: </label>
                                            <input type="number" className="form-control mt-1" placeholder="YTD medical spend: $$$$$" value={this.state.accumulator || ''} onChange={(e) => this.setState({ accumulator: e.target.value })} disabled={this.state.token === null} pattern="[0-9]*" inputMode="numeric" />
                                        </div>

                                        <button className="btn btn-orange bannerseachPlaceHoldercolor m-auto d-block" data-dismiss="modal" disabled={this.state.stateName == '' || this.state.accumulator == '' || this.state.msaName === '' || this.state.lives === '' || this.state.accumulator === '' || !this.numberValid(this.state.accumulator) || this.state.paymentMethod == ''} onClick={this.oopCustomSubmit}>Get Rates</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* How to buy low cost healthcare modal  */}
                        <div className="modal fade" id="buy_low_cost_Modal">
                            <div className="modal-dialog modal-dialog-scrollable modal-lg">
                                <div className="modal-content ">
                                    <div className="modal-header">
                                        <h5 className="modal-title">{this.state.lowCostPopupContext?.headding}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body ">
                                        <ol>

                                            {
                                                this.state.lowCostPopupContext?.content.map(
                                                    (text, key) => <li dangerouslySetInnerHTML={{ __html: text.text }} key={key}></li>)
                                            }

                                        </ol>



                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Upload and reprice your medical bill  */}
                        <div className="modal fade" id="Surgical_Imaging" data-backdrop="static">
                            <div className="modal-dialog modal-dialog-scrollable modal-lg">
                                <div className="modal-content ">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Upload and reprice your medical bill</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.setState({ files: [], response: null })}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body ">
                                        {
                                            this.state.response ?
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-6 col-sm-6 col-12  my-2">
                                                            <select
                                                                className="md-form mdb-select white-bg form-control w-100"
                                                                name="selectState"
                                                                onChange={(e) => this.setState({ selectedHospitalId: e.target.value, selectedHospitalName: e.target.selectedOptions[0].getAttribute('hospitalname') })}
                                                                required
                                                                value={this.state.selectedHospitalId}
                                                                disabled

                                                            >
                                                                <option value="">Select Hospital</option>
                                                                {

                                                                    this.state.hospitalList
                                                                        .sort((a, b) => a.facilityName.localeCompare(b.facilityName))
                                                                        .map((hptlitm, index) => (
                                                                            <option
                                                                                value={
                                                                                    hptlitm.hospitalID
                                                                                }
                                                                                key={index}
                                                                            >
                                                                                {hptlitm.facilityName}
                                                                            </option>
                                                                        ))

                                                                }
                                                            </select>
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 col-12  my-2">
                                                            <select
                                                                className="md-form mdb-select white-bg form-control w-100"
                                                                name="paymentMethod"
                                                                onChange={(e) => this.handleSettingChange(e)}
                                                                required
                                                                value={this.state.paymentMethod}
                                                                disabled

                                                            >
                                                                <option value="">Select Billing Class</option>
                                                                {
                                                                    this.getBillingClasses().map((billingClass, index) => (
                                                                        <option
                                                                            value={billingClass}
                                                                            key={index}
                                                                        >
                                                                            {billingClass}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>

                                                        <div className="col-12  my-2 text-center">
                                                            <div className="form-group mb-0">
                                                                <p className="mb-0">Your selected file:
                                                                    &nbsp;<strong >
                                                                        {this.state.files?.map((itm) => itm.name).join(', ')}
                                                                    </strong></p>
                                                            </div>
                                                        </div>

                                                        {
                                                            this.state.response?.employers_dc ?
                                                                <div className="col-12  text-center">
                                                                    {/*<OcrImageUpload /> */}

                                                                    <div className="alert alert-success alert-dismissible fade show py-2" role="alert">Thank you for uploading the image. We will send an email with the report once it's ready.</div>
                                                                </div>
                                                                :
                                                                <div className="col-12  text-center">
                                                                    <h5>
                                                                        You need to pay total <strong className="text-danger">${this.state.response?.data.map((itm) => itm.price).reduce((acc, price) => acc + price, 0)}</strong> for the selected file OCR scanning.
                                                                    </h5>
                                                                    {/* <Link to="/ocr-checkout" className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn">Procced to pay</Link> */}
                                                                    <a href="/ocr-checkout" className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn">Procced to pay</a>



                                                                </div>
                                                        }





                                                    </div>
                                                </>

                                                : <>
                                                    <p >Dear User — We are using a publicly available AI large language model to read you bill. We are not scraping any personal information or account numbers from your bill and recommend redacting any personal information (names, addresses, account numbers). By clicking the upload button you acknowledge that we are not scraping personal information and hold us harmless for any loss of personal information.</p>
                                                    <p>Some medical bills do not contain cpt codes. Just revenue codes. Revenue code 450 is for the emergency room. Emergency room codes are 99281-99285. When cpt codes are not present we will apply the charges to the rate for code 99284, then apply that discount to all other codes. The charges are relative to the expected payment. If the hospital objects to the payment have them send to you an itemized bill listing all cpt codes. The rate we are choosing is the 20th percentile of commercial rates (can be changed by hospital) or the cash rate if its cheaper. Commercial rates are set in good faith to cover the cost of delivering care. The hospital should not object to payment amount since they are receiving the same payment they freely accept from other people.</p>
                                                    <p><strong>**Please note anesthesia prices are charged in 15 minute intervals. Anesthesia bills without units and modifiers cannot be priced. There is price variability in drug codes (JCodes) due to different dosages. We’ve provided all the different dosages for the JCode at the hospital and in your metro area. You will have to read the detail to make sure the drug and dosages reported in the price transparency file matches your bill. Lastly, there is variability in room charges based on the type of room. We’ve provided the room prices (if available). You will have to read the detail to make sure the room type matches your bill.</strong></p>

                                                    {
                                                        !this.state.oCR_Access && this.state.nextSearchDate ? <div className="alert alert-danger alert-dismissible fade show py-2" role="alert">Your access to upload and reprice your medical bill is currently unavailable. The next eligible date for this service is {this.state?.nextSearchDate.toLocaleDateString('en-US')}.</div> :
                                                            !this.state.stateName || !this.state.msaID ?
                                                                <div className="alert alert-danger alert-dismissible fade show py-2" role="alert">Please select state and metro area first</div> : ''

                                                    }

                                                    {
                                                        this.state.uploadError ? <div className="alert alert-danger alert-dismissible fade show py-2" role="alert">
                                                            {this.state.uploadErrorMessage}
                                                            <button type="button" className="close py-2" data-dismiss="alert" aria-label="Close" onClick={() => this.setState({ uploadError: false })}>
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div> : ''
                                                    }


                                                    <div className="row">


                                                        <div className="col-md-6 col-sm-6 col-12  my-2">
                                                            <select
                                                                className="md-form mdb-select white-bg form-control w-100"
                                                                name="selectState"
                                                                onChange={(e) => this.setState({ selectedHospitalId: e.target.value, selectedHospitalName: e.target.selectedOptions[0].getAttribute('hospitalname') })}
                                                                required
                                                                value={this.state.selectedHospitalId}
                                                                disabled={this.state.token === null || !this.state.hospitalList || !this.state.stateName || !this.state.msaID}

                                                            >
                                                                <option value="">Select Hospital</option>
                                                                {

                                                                    this.state.hospitalList
                                                                        .sort((a, b) => a.facilityName.localeCompare(b.facilityName))
                                                                        .map((hptlitm, index) => (
                                                                            <option
                                                                                value={
                                                                                    hptlitm.hospitalID
                                                                                }
                                                                                key={index}
                                                                            >
                                                                                {hptlitm.facilityName}
                                                                            </option>
                                                                        ))

                                                                }
                                                            </select>
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 col-12  my-2">
                                                            <select
                                                                className="md-form mdb-select white-bg form-control w-100"
                                                                name="paymentMethod"
                                                                onChange={(e) => this.handleSettingChange(e)}
                                                                required
                                                                value={this.state.paymentMethod}
                                                                disabled={this.state.token === null || !this.state.Setting.length}

                                                            >
                                                                <option value="">Select Billing Class</option>
                                                                {
                                                                    this.getBillingClasses().map((billingClass, index) => (
                                                                        <option
                                                                            value={billingClass}
                                                                            key={index}
                                                                        >
                                                                            {billingClass}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>

                                                        <div className="col-12 my-2">

                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input bg-blue-checkbox"
                                                                    type="checkbox"
                                                                    value=""
                                                                    id="defaultCheck1"
                                                                    onChange={(e) => this.setState({ isPhoneChecked: e.target.checked })}
                                                                />
                                                                <label
                                                                    className="form-check-label btntext"
                                                                    for="defaultCheck1"
                                                                >
                                                                    Results and supporting data will be emailed to you, do you also want a text message? By checking this box and submitting, you agree to receive a one-time SMS with a secure link to your report.
                                                                </label>
                                                            </div>

                                                            {
                                                                this.state.isPhoneChecked &&

                                                                <div className="input-group" style={{ width: "clamp(4rem, 48%, 100%)" }}>
                                                                    <div className="input-group-prepend">
                                                                        <select className="custom-select" title="Country Code" defaultValue={this.state.countryNumber} onChange={(e) => this.setState({ countryNumber: e.target.value })}>
                                                                            <option value={"+1"} selected>+1</option>
                                                                            {/* <option value={"+91"} selected>+91</option> */}
                                                                        </select>
                                                                    </div>
                                                                    <input type="tel" className="form-control" placeholder="Enter Phone Number" aria-label="Enter Phone Number" aria-describedby="basic-addon2" pattern="[0-9]*" inputMode="numeric" value={this.state.phoneNumber} onChange={(e) => this.setState({ phoneNumber: e.target.value })} />

                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 col-12  my-2">
                                                            <div className="d-flex justify-content-center">
                                                                <label
                                                                    for="fileUpload"
                                                                    className="file-upload btn bg-orange btn-block rounded-pill shadow text-white w-50 "
                                                                >
                                                                    Add Bills
                                                                    <i className="fa fa-upload ml-2"></i>
                                                                    <input
                                                                        id="fileUpload"
                                                                        type="file"
                                                                        name="uploadFile"
                                                                        onChange={this.handleFileChange}
                                                                    />
                                                                </label>
                                                            </div>
                                                            <div className="form-group">
                                                                <small className="text-center">
                                                                    {this.state.files?.map((itm) => itm.name).join(', ')}
                                                                </small>
                                                            </div>
                                                        </div>



                                                        <div className="col-md-6 col-sm-6 col-12  my-2 text-center">
                                                            <button onClick={this.handleUpload} disabled={this.state.uploading || !this.state.stateName || !this.state.msaID || !this.state.oCR_Access || !this.state.selectedHospitalId} className="btn btn-orange bannerseachPlaceHoldercolor home_search_btn">
                                                                {this.state.uploading ? "Uploading..." : "Upload Bills"}
                                                            </button>
                                                        </div>

                                                    </div>

                                                    <p className="text-center"><small>You will be charged 86 cents for documents up to 6 pages.  This is the cost of the ai technology; not ours.</small></p>

                                                    <div className="row">
                                                        <div className="col-12 text-center">
                                                            <ul className="list-inline mt-3 upload-bill-footer">
                                                                <li className="list-inline-item">
                                                                    <a href="/terms-condition">Terms & Conditions</a>
                                                                </li>
                                                                <li className="list-inline-item">|</li>
                                                                <li className="list-inline-item">
                                                                    <a href="/privacy-policy">Privacy Policy</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Upload and reprice your medical bill  */}
                        <div className="modal fade" id="OcrlastStep" data-backdrop="static" >
                            <div className="modal-dialog modal-dialog-scrollable payment_process_modal">
                                <div className="modal-content ">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Upload and reprice your medical bill</h5>

                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                this.setState({
                                                    response: null,
                                                    paymentSusscess: false,
                                                    ocrInProcess: false
                                                });

                                                // Push the new URL to history (navigate)
                                                this.props.history.push("/");
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>

                                    </div>
                                    <div className="modal-body ">

                                        <span data-dismiss="modal" ref={this.ocrProcessRef} ></span>

                                        {
                                            this.state.paymentSusscess && this.state.ocrInProcess &&
                                            // <OcrImageUpload />
                                            <div className="alert alert-success alert-dismissible fade show py-2" role="alert">Your Payment has been Completed. OCR scanning is under process. We will send an email with the report once it's ready.</div>
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Omega Notes  */}
                        <div className="modal fade" id="Omega_Notes">
                            <div className="modal-dialog modal-dialog-scrollable modal-lg">
                                <div className="modal-content ">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Omega Notes</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body ">
                                        <p >Omega Notes is a knowledge management solution that connects employees with the knowledge they need when they need it… including how to save on healthcare expenses using Health Cost Labs. Through the <a href="https://business.omeganotes.com/main_app?community=1666977935429x786726420295974900&nav=section" target="_blank">Health Cost Labs Alpha Community</a> on Omega Notes, employees can get their questions answered on how to shop for healthcare, get estimates, hear purchasing stories and get the best care at the lowest price.<br></br>Omega Notes believes a knowledgeable employee is a safer, healthier, and more motivated employee. To learn how you can further engage and align your workforce through knowledge sharing and transparency, visit Omega Notes.”</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>




                    <div className="mt-3 pt-3 home-about-sec">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    {/* <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/jX3aHRNAkPs"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe> */}
                                    {/* <video
                                        width="100%"
                                        height="315"
                                        poster="https://mms.businesswire.com/media/20210426005489/en/873778/5/high-res.jpg"
                                        controls className="home-video"
                                    >
                                        <source
                                            src="https://mms.businesswire.com/media/20210426005489/en/873778/19/5005979_yt1s.com_-_Power_to_the_Patients_Prices_are_Now_a_Patients_Right_1080p_1.mp4&.mp4?download=1"
                                            type="video/mp4"
                                        />
                                        <source
                                            src="movie.ogg"
                                            type="video/ogg"
                                        />
                                        Your browser does not support the video
                                        tag.
                                    </video> */}
                                    <iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/miiyJ5cU-kw?si=i2w7q_VkGqvXV7-J"
                                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
                                    </iframe>


                                </div>
                                <div className="col-md-6">
                                    <p className="bold_text_no_text_transform text-center">
                                        {/* Public Service Announcement airs during
                                        Oscars, featuring */}
                                        Please watch this video on how to use
                                    </p>
                                    <p className="bold_text_no_text_transform text-center">
                                        {/* Susan Sarandon & Cynthia Erivo,
                                        proclaiming Prices are */}
                                        the price transparency data to dispute your medical bills.
                                    </p>
                                    {/* <p className="bold_text_no_text_transform text-center">
                                        now a Patient’s Right
                                    </p> */}
                                    <p className="card-text text-justify pl-5">
                                        {/* Activist and Academy-Award winning
                                        actress Susan Sarandon and Grammy, Emmy
                                        and Tony Award-Winning and Academy-
                                        Award nominated actress Cynthia Erivo
                                        starred in a new public service
                                        announcement (PSA) during the Oscars
                                        titled “Power to the Patients” which
                                        focuses on increasing awareness that
                                        hospital prices are now a patient’s
                                        right prior to receiving care. */}
                                        <a href="https://en.wikipedia.org/wiki/Uniform_Commercial_Code"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#e8ac4c", fontWeight: "bold", textDecoration: "underline" }}>
                                            The Uniform Commercial Code (UCC) is a comprehensive set of laws governing all commercial transactions in the United States.
                                        </a>&nbsp;Within these laws is a law called Open Price Term.
                                        An open price term is a contract for sale in which nothing is said as to price,
                                        the price is to be agreed later by parties, the price is to be fixed by a market standard or by a third party,
                                        or the price is to be fixed in good faith by the seller or buyer.
                                    </p>
                                    <p className="card-text text-justify pl-5" >
                                        *This is not legal advice. Consult your attorney if the hospital does not accept your price for payment in full.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-bg-light-gray mt-5 pt-3">
                        <div className="container pb-5">
                            <div className="row">
                                <div className="col-md-6">
                                    <h3 className="bold_text_no_text_transform font20">
                                        Hospital Rates are now Public
                                    </h3>
                                    <p>
                                        Health Cost Labs informs you of lower
                                        cost alternatives using billions of
                                        rates grouped by:
                                    </p>
                                    <p>
                                        —&gt; MSA Regions
                                        <br />
                                        —&gt; Carriers
                                        <br />
                                        —&gt; Hospitals
                                        <br />
                                        —&gt; Products
                                    </p>
                                    <p>We offer Rates for use by:</p>
                                    <p>
                                        —&gt; Employers
                                        <br />
                                        —&gt; Health Plans
                                        <br />
                                        —&gt; Hospitals & Doctors
                                        <br />
                                        —&gt; Consumers
                                        <br />
                                        —&gt; Benefit Companies
                                    </p>
                                    <p>
                                        We can support all segments with
                                        analytics, benchmark and cost savings
                                        opportunities:
                                    </p>
                                    <p>
                                        —&gt; Benchmarking: Medicare & Peer
                                        review
                                        <br />
                                        —&gt; Network Optimization and Cost
                                        Savings
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <h3 className="bold_text_no_text_transform text-center pt-3 font20">
                                        <u className="underline-text">
                                            STATE OF ALASKA
                                        </u>
                                    </h3>
                                    <div className="card card_border_padding">
                                        <img
                                            src="images/Hospital image 3.jpg"
                                            className="card-img-top"
                                            alt="..."
                                        ></img>
                                        <div className="card-body text-center">
                                            <Link
                                                to="/pivotTable"
                                                className="btn btn-orange tag-btn"
                                            >
                                                <img
                                                    className="pr-2"
                                                    src="images/view-icon.png"
                                                />
                                                View Files
                                                <span className="badge rounded-pill badge-notification">
                                                    Free
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span data-toggle="modal" data-target="#OcrlastStep" ref={this.OcrlastStep} ></span>
                </main>
            </>
        );
    }
}

export default Home;
